module.exports = __webpack_public_path__ + "static/img/Clothing.f1972d0.png";